<div class="container my-3">
  <!-- <h1 class="mb-3">Add Element Models</h1> -->
  <form #form="ngForm" (ngSubmit)="addModel()" class="mt-4">
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Manufacturer:</label>
      </div>
      <div class="col-sm-4" style="float: left">
        <select
          class="form-select border border-dark"
          aria-label="select example"
          [(ngModel)]="addModelRequest.ManufacturerId"
          name="manufacturerId"
          #addModelManId="ngModel"
        >
          <option [ngValue]="null" selected="true" disabled>
            Select Manufacturer
          </option>
          <option
            *ngFor="let manufacturer of manufacturers"
            value="{{ manufacturer.Id }}"
            selected
          >
            {{ manufacturer.Name }}
          </option>
        </select>
        <div
          *ngIf="
            addModelRequest.ManufacturerId === null &&
            (addModelManId.touched || addModelManId.dirty)
          "
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
        <div
          *ngIf="ManufacturerIdError"
          class="text-danger"
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Type:</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          style="float: left"
          [(ngModel)]="addModelRequest.Type"
          name="Type"
          #addModeltype="ngModel"
        >
          <option [ngValue]="null" disabled>Select Type</option>
          <option
            type="number"
            *ngFor="let type of types"
            value="{{ type.Id }}"
            selected
          >
            {{ type.TypeName }}
          </option>
        </select>
        <div
          *ngIf="
            addModelRequest.Type === null &&
            (addModeltype.touched || addModeltype.dirty)
          "
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
        <div
          *ngIf="TypeError"
          class="text-danger"
          style="text-align: left; color: gray"
        >
          This field is required
        </div>
      </div>
    </div>
  </form>
  <form [formGroup]="AddModelForm" (ngSubmit)="addModel()">
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Name:</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="name"
          style="float: left"
          name="name"
          formControlName="Name"
          required
          autocomplete="on"
          [ngClass]="{
            'is-invalid':
              (submitted || AddModelForm.controls.Name.touched) &&
              AddModelForm.controls.Name.errors
          }"
        />
        <div
          *ngIf="
            (submitted || AddModelForm.controls.Name.touched) &&
            AddModelForm.controls.Name.errors
          "
          class="text-danger"
          style="text-align: left"
        >
          This field is required
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Membrane Area:</label>
      </div>
      <div class="col-sm-4">
        <input
          type="number"
          style="float: left"
          class="form-control border border-dark"
          id="Ma"
          formControlName="Ma"
          name="Ma"
          [ngClass]="{
            'is-invalid':
              (submitted || AddModelForm.controls.Ma.touched) &&
              AddModelForm.controls.Ma.errors
          }"
        />
        <div
          *ngIf="
            (submitted || AddModelForm.controls.Ma.touched) &&
            AddModelForm.controls.Ma.errors
          "
          class="text-danger"
          style="text-align: left"
        >
          This field is required
        </div>
      </div>
    </div>
  </form>
  <form #form="ngForm" (ngSubmit)="addModel()">
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">TCFA:</label>
      </div>
      <div class="col-sm-4">
        <input
          type="number"
          style="float: left"
          class="form-control border border-dark"
          id="tcfa"
          name="tcfa"
          [(ngModel)]="addModelRequest.Tcfa"
          required
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">TCFB:</label>
      </div>
      <div class="col-sm-4">
        <input
          type="number"
          style="float: left"
          class="form-control border border-dark"
          id="tcfb"
          name="tcfb"
          [(ngModel)]="addModelRequest.Tcfb"
          required
        />
      </div>
    </div>
    <div style="min-height: 50px"></div>
    <div class="row">
      <div class="col-sm-2" style="text-align: right">
      
      </div>
      <div class="col-sm-2" style="text-align: left">
        <button type="submit" class="btn custom-buttons-btn mt-3">Submit</button>
      </div>
    </div>
  </form>
</div>
